import { search } from "../BaseRepositoryComponents";

const baseUrl = process.env.REACT_APP_NEW_PAINEL_API_URL;

export function getDocumentTypes() {
  return search({
    path: `${baseUrl}/v1/document_type`,
    method: "GET",
  });
}
